import { useState } from "react";
import { requestMagicLink, startPhaseSession } from "./auth-client";
import { ThemeToggle } from "./App";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "sending" | "sent" | "error">("idle");
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    startPhaseSession(email);
    window.location.href = "/";
  }

  async function sendLink() {
    if (!email.includes("@")) { setError("Inserisci una email solo se vuoi ricevere il magic link."); return; }
    setStatus("sending"); setError(null);
    const r = await requestMagicLink(email);
    if (r.ok) setStatus("sent");
    else { setError(r.error ?? "Errore sconosciuto"); setStatus("error"); }
  }

  return (
    <div className="min-h-screen px-6 py-10 bg-slate-50 dark:bg-slate-950 transition-colors">
      <div className="max-w-md mx-auto space-y-6">
        <div className="flex items-start justify-between">
          <header>
            <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100">PRORA — Accedi</h1>
            <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">
              In questa fase puoi entrare senza convalida email. Il magic link resta disponibile come opzione.
            </p>
          </header>
          <ThemeToggle />
        </div>

        {status === "sent" ? (
          <div className="border border-emerald-300 dark:border-emerald-700 bg-emerald-50 dark:bg-emerald-950/40 rounded-lg p-5 transition-colors">
            <div className="font-medium text-emerald-900 dark:text-emerald-200">Link inviato.</div>
            <div className="text-sm text-emerald-800 dark:text-emerald-300 mt-2">
              Controlla la casella di <strong>{email}</strong>. Clicca sul link
              ricevuto per accedere. Il link è valido 15 minuti.
            </div>
            <button
              onClick={() => { setStatus("idle"); setEmail(""); }}
              className="mt-4 text-sm text-emerald-900 dark:text-emerald-200 underline"
            >
              Invia a un'altra email
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 rounded-lg p-5 space-y-4 transition-colors">
            <label className="block">
              <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Email</span>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="opzionale"
                className="mt-1 w-full border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 rounded px-3 py-2 text-sm"
              />
            </label>
            {error && (
              <div className="text-sm text-rose-700 dark:text-rose-300 bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-800 rounded p-3">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={status === "sending"}
              className="w-full px-4 py-2 bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900 rounded text-sm hover:bg-slate-800 dark:hover:bg-slate-200 disabled:opacity-50 transition-colors"
            >
              entra senza convalida email
            </button>
            <button
              type="button"
              onClick={sendLink}
              disabled={status === "sending" || !email.includes("@")}
              className="w-full px-4 py-2 border border-slate-300 dark:border-slate-700 rounded text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-50 transition-colors"
            >
              {status === "sending" ? "invio…" : "ricevi magic link via email"}
            </button>
          </form>
        )}

        <p className="text-xs text-slate-500 dark:text-slate-500">
          Accesso temporaneo di fase: utile per provare feedback e bacheca senza attendere SMTP.
          Il modello definitivo resta passwordless via email.
        </p>

        <a href="/" className="text-sm text-slate-600 dark:text-slate-400 underline">← torna alla home</a>
      </div>
    </div>
  );
}
